<template>
	<div class="rb-particles" v-if="visible">
		<component
			class="particle"
			v-for="i in elements"
			:key="i"
			:is="getParticleType(i)"
			@destroy="removeElement(i)"
		></component>
	</div>
</template>

<script>
	import SnowParticle from './particles/SnowParticle/SnowParticle';
	import CinderParticle from './particles/CinderParticle/CinderParticle';

	const particles = [CinderParticle, SnowParticle];

	export default {
		name: 'RbParticles',
		props:  {
			newOn: {
				type: [Function, Number],
				default: 150
			},
			maxParticles: {
				type: Number,
				default: 40
			},
		},
		data: () => ({
			i: 0,
			elements: [],
			visible: true
		}),
		created() {
			this.addElement();
		},
		mounted() {
			this.bindGlobalEvents();
		},
		beforeDestroy() {
			this.unbindGlobalEvents();
		},
		methods: {
			getParticleType(i) {
				return particles[i % particles.length]
			},
			removeElement(i){
				this.elements.remove(i);
			},
			addElement() {
				requestAnimationFrame(() => {
					if (this.visible) {
						if (this.elements.length < this.maxParticles) {
							this.i++;
							this.elements.push(this.i);
						}
					} else if (this.elements.length) {
						this.i = 0;
						this.elements = [];
					}

					let timeout = this.newOn instanceof Function ? this.newOn() : this.newOn;

					setTimeout(
						() => this.addElement(),
						timeout + (timeout/2) * Math.random()
					);
				});
			},

			bindGlobalEvents() {
				document.addEventListener('fullscreenchange', this.onFullScreenChange);
				document.addEventListener('blur', this.onBlur);
				document.addEventListener('focus', this.onFocus);
			},
			unbindGlobalEvents() {
				document.removeEventListener('fullscreenchange', this.onFullScreenChange);
				document.removeEventListener('blur', this.onBlur);
				document.removeEventListener('focus', this.onFocus);
			},

			onFullScreenChange() {
				this.visible = !document.fullscreenElement;
			},
			onBlur() {
				this.visible = false;
			},
			onFocus() {
				this.visible = true;
			}
		}
	}
</script>

<style lang="scss" scoped>
	.rb-particles {
		position: fixed;
		left: 0;
		top: -20px;
		bottom: -10px;
		right: 0;
		z-index: -50;
		overflow: hidden;

		.particle {
			pointer-events: none;
			position: absolute;
		}
	}
</style>
